<script lang="ts">
	import { ClippingMask, MaskBase } from "luxedo-canvas/asset"
	import { MaskSidebarController } from "./MaskEditorSidebarController"
	import { MaskEditorController } from "../MaskEditorController"
	import { HouseSections } from "luxedo-data"
	import { Responsive } from "responsive"

	let maskEdit: ClippingMask | MaskBase = $state()
	let selectedSection: string = $state()
	let trackName: string = $state()
	let maskAffects: "in" | "out"

	let isMobile = $derived(Responsive.isMobile)

	MaskSidebarController.subscribe(({ mask }) => initMaskData(mask))

	function initMaskData(mask: ClippingMask | MaskBase) {
		if (!mask) return

		maskEdit = mask
		selectedSection = mask.data.section
		trackName = mask.name
		maskAffects = mask.inverted ? "out" : "in"
	}

	function cancel() {
		MaskEditorController.cancelEdit()
	}

	function complete() {
		MaskEditorController.completeEdit()

		maskEdit.name = trackName
		maskEdit.data.section = selectedSection
	}
</script>

<div class="mask-edit-menu">
	<div class="heading">
		<h3>Editing {maskEdit?.name}</h3>
	</div>
	<p class="info">
		{Responsive.isMobile ? "Tap" : "Click"} and drag the points on Mask to edit. {Responsive.isMobile
			? "Double tap"
			: "Click"} along the outline to create new points {!Responsive.isMobile
			? "or hold alt and click points to remove them"
			: ""}.
	</p>
	<hr />

	<div class="select-container full-width">
		<label for="mask-layer-input">Section: </label>
		<select id="mask-layer-input" bind:value={selectedSection}>
			<option value={undefined}>-- Select Section --</option>
			{#each HouseSections as section}
				<option value={section}>{section}</option>
			{/each}
			<option value="other">Other</option>
		</select>
	</div>

	<div class="input-container full-width">
		<label for="name-input">Name: </label>
		<input type="text" id="name-input" bind:value={trackName} />
	</div>
	<br />

	<!-- <div id="visibility-input" class="input-container">
		<span class="label">Visible: </span>
		<IconRowSelector
			bind:selectedOption={maskAffects}
			options={{
				in: {
					comp: MaskInsideIcon,
					title: "Show Inside Mask",
				},
				out: {
					comp: MaskOutsideIcon,
					title: "Show Outside Mask",
				},
			}}
		/>
		<span class="visibility-text">{maskAffects === "in" ? "Inside" : "Outside"}</span>
	</div> -->
</div>
<div class="button-container" id="edit-buttons">
	<button class="warn" onclick={cancel}>Cancel</button>
	<button onclick={complete}>Complete</button>
</div>

<style>
	h3 {
		font-size: var(--h0);
		margin: 0;
	}

	.mask-edit-menu {
		flex-grow: 1;
	}

	.button-container,
	.mask-edit-menu {
		padding-right: 0.5rem;
	}

	.button-container {
		margin-bottom: 0;
		justify-content: flex-end;
	}

	.button-container button:not(:first-of-type) {
		margin-left: 0.5rem;
	}

	label {
		font-size: var(--h3);
		color: var(--color-text);
		margin-right: 0.5rem;
	}

	:global(.isMobile) .mask-edit-menu {
		padding-right: 0;
		flex-grow: 0;
	}

	:global(.isMobile #sidebar) .button-container#edit-buttons {
		position: fixed;
		bottom: 0.5rem;
		left: 0;
		width: 100%;
		padding: 0 0.5rem;
		z-index: 1;
	}

	:global(.isMobile #sidebar) .button-container#edit-buttons button {
		flex-basis: calc(50% - 0.25rem);
		text-align: center;
		font-size: var(--h2);
	}
</style>
